<template>
  <section class="dashboard">
    <div class="top-bar">
      <div class="top-bar--left">
        <b-button v-if="isUserInOrganisation" @click="handleSwitchTab(0)" size="-tab" variant="-gray"
                  :class="{ 'btn--primary': tabIndex === 0 }">{{$t('history.nav.me')}}
        </b-button>
        <b-button v-if="isUserInOrganisation" @click="handleSwitchTab(1)" size="-tab" variant="-gray"
                  :class="{ 'btn--primary': tabIndex === 1 }">{{$t('history.nav.org')}}
        </b-button>
      </div>
      <div class="top-bar--right">

        <date-range-picker v-model="dateRange" @input="handleDatePickerInput"></date-range-picker>

        <b-form-input :placeholder="$t('history.nav.search')" v-model="search" @keydown.enter.native="handleConfirmSearch" list="my-history-search" autocomplete="off" class="inp inp--combo inp--search"></b-form-input>
        <b-button variant="-combo btn--ternary btn--outline" @click="handleConfirmSearch"><i class="icon icon--search"></i></b-button>
        <datalist id="my-history-search">
          <option v-for="(item, index) in autocomplete" :key="index">{{ item }}</option>
        </datalist>
      </div>
    </div>
    <div v-if="!isUserInOrganisation || tabIndex===0">
      <printing-history key="user" type="user" :date-range="dateRangeObject" :search="confirmedSearch"></printing-history>
    </div>
    <div v-else-if="isUserInOrganisation && tabIndex===1">
      <printing-history key="org" type="org" :date-range="dateRangeObject" :search="confirmedSearch"></printing-history>
    </div>
  </section>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import moment from "moment";

  import PrintingHistory from "../components/dashboard/PrintingHistory";
  import DateRangePicker from "../components/DateRangePicker";

  export default {
    name: "Dashboard",
    components: {
      DateRangePicker,
      PrintingHistory
    },
    data() {
      return {
        tabIndex: 0,
        search: null,
        confirmedSearch: null,
        dateRange: null,
        autocomplete: [],
        autocompleteFetched: false,
        datePicketAttrs: [
          {
            key: 'today',
            dot: true,
            dates: new Date(),
          },
        ]
      }
    },

    computed: {
      ...mapGetters(['isUserInOrganisation']),

      dateRangeObject() {
        if (!this.dateRange) {
          return null;
        }
        return {
          start: moment(this.dateRange.start).hour(0).minute(0).second(0).unix(),
          end: moment(this.dateRange.end).hour(23).minute(59).second(59).unix()
        };
      }
    },

    methods: {
      ...mapActions(['fetchJobHistoryAutocomplete']),

      handleConfirmSearch() {
        const search = this.search ? this.search : null;
        if (search !== this.confirmedSearch) {
          this.confirmedSearch = search;
        }
      },

      handleDatePickerInput() {
        this.clearAutocomplete();
      },

      clearAutocomplete() {
        this.autocomplete = [];
        this.autocompleteFetched = false;
      },

      handleSwitchTab(index) {
        if (this.tabIndex === index) {
          return;
        }
        this.dateRange = null;
        this.search = '';
        this.confirmedSearch = '';
        this.clearAutocomplete();
        this.tabIndex = index;
      }
    },

    watch: {
      search: function(newVal, oldVal) {
        if ((newVal.length === 3 && oldVal && oldVal.length < 3) || (newVal.length >= 3 && !this.autocompleteFetched)) {
          const params = {
            isOrganization: this.tabIndex === 1,
            search: newVal.substr(0, 3),
            startDate: this.dateRange ? this.dateRange.start : null,
            endDate: this.dateRange ? this.dateRange.end : null
          };
          this.fetchJobHistoryAutocomplete(params).then(({data}) => {
            this.autocompleteFetched = true;
            if (data.result) {
              this.autocomplete = data.message;
            }
          });
        } else if (newVal.length < 3) {
          this.autocomplete = [];
        }
      }
    }
  }
</script>

<style lang="scss">
  @import ".././scss/theme";

  .dashboard {
    .date-range-component {
     .inp {
       width: 240px;
     }
    }

  .inp--search {
      min-width: 420px;
      margin-left: 10px;
    }
    .inp--combo {
      width: 200px;
    }

    .b-dropdown {
      margin-left: 0;
    }

    &__overview {
      margin: 24px -10px 18px;

      &__item {
        padding: 10px;

        &:last-child {
          margin-right: 0;
        }

        div {
          background: white;
          border-radius: $s-border-radius;
          text-align: center;
        }
        span {
          font-size: 20px;
          padding: 8px;
          font-weight: 300;
          display: block;
        }
        p {
          background: $c-blue;
          padding: 5px;
          color: white;
          font-size: 13px;
          font-weight: 500;
          text-transform: $f-case;
          border-bottom-left-radius: $s-border-radius;
          border-bottom-right-radius: $s-border-radius;
        }


        &:nth-child(1) {
          p {
            background: $c-primary;
          }
        }
        &:nth-child(2) {
          p {
            background: $c-primary;
          }
        }
        &:nth-child(3) {
          p {
            background: $c-primary;
          }
        }
        &:nth-child(4) {
          p {
            background: $c-primary;
          }
        }
        &:nth-child(5) {
          p {
            background: $c-primary;
          }
        }
        &:nth-child(6) {
          p {
            background: $c-primary;
          }
        }
      }
    }
  }
</style>
